import type { SettingsPage } from "../types";

const highlightSettings: SettingsPage = {
  id: "highlights",
  label: "Highlights",
  order: 2,
  items: [
    {
      key: "appearanceHeading",
      label: "Appearance",
      type: "heading",
      default: "",
    },
    {
      key: "defaultColor",
      label: "Default highlight color",
      type: "color",
      default: "#ffff00",
      description: "Used when a highlight has no code color assigned.",
    },
    {
      key: "opacity",
      label: "Highlight opacity",
      type: "number",
      default: 0.4,
      min: 0.1,
      max: 1,
      step: 0.05,
      description: "How opaque highlighted text appears, in the editor and in PDF tabs.",
    },
  ],
};

export default highlightSettings;
